export default "/_next/static/images/0d9b0de9368fabc374b0d46de73a3142.svg";